import toast from "react-hot-toast";
import { ActiveUsersExportParams } from "../models/activeUsersMetrics";
import { useExportActiveUsersMutation } from "../store/services/activity";
import { getApiErrorMessage } from "../utils/functions/api-errors";
import { downloadBlob, buildAnalyticsExportFilename } from "../utils/functions/downloadBlob";
import { useTenantOptions } from "./useTenantOptions";

/** Export CSV de la nómina de usuarios activos de la ventana seleccionada. */
export function useActiveUsersExport(): {
  exportActiveUsers: (params: ActiveUsersExportParams) => Promise<void>;
  isExporting: boolean;
} {
  const [exportActiveUsersMutation, { isLoading: isExporting, reset }] =
    useExportActiveUsersMutation();

  const { options: tenantOptions } = useTenantOptions();

  const exportActiveUsers = async (params: ActiveUsersExportParams) => {
    try {
      const result = await exportActiveUsersMutation(params).unwrap();

      if (result.status === 204) {
        toast("No hubo actividad en la ventana seleccionada", { icon: "ℹ️" });
        return;
      }

      downloadBlob(result.blob, buildAnalyticsExportFilename(result.filename, tenantOptions));
      toast.success("CSV exportado");
    } catch (exportError: unknown) {
      toast.error(getApiErrorMessage(exportError) ?? "Error al exportar el CSV");
    } finally {
      // Sin esto el blob queda retenido en el store de RTK hasta desmontar la pantalla.
      reset();
    }
  };

  return { exportActiveUsers, isExporting };
}
